import * as types from "./types";
import { combineReducers } from "redux";

function inscripcionesPorColegio(state = [], action) {
  switch (action.type) {
    case types.INSCRIPCIONES_POR_COLEGIO:
      return action.payload;
    case types.RESET_INSCRIPCIONES_POR_COLEGIO:
      return [];
    default:
      return state;
  }
}

function inscripcionesDelColegio(state = [], action) {
  switch (action.type) {
    case types.INSCRIPCIONES_DEL_COLEGIO:
      return action.payload;
    case types.RESET_INSCRIPCIONES_DEL_COLEGIO:
      return [];
    default:
      return state;
  }
}

function datosColegio(state = {}, action) {
  switch (action.type) {
    case types.OBTENER_DATOS_COLEGIO:
      return action.payload;
    case types.LIMPIAR_DATOS_COLEGIO:
      return {};
    default:
      return state;
  }
}

function datosInscripcion(state = {}, { type, payload }) {
  return type === types.OBTENER_DATOS_INSCRIPCION
    ? payload
    : type === types.LIMPIAR_DATOS_INSCRIPCION
      ? {}
      : state;
}

function dataSaved(state = { status: false, message: "" }, action) {
  switch (action.type) {
    case types.DATA_SAVED:
      return action.payload;
    case types.RESET_DATA_SAVED:
      return { status: false, message: "" };
    default:
      return state;
  }
}

function filtrosAplicados(state = null, action) {
  switch (action.type) {
    case types.APLICAR_FILTROS:
      return action.payload;
    case types.RESET_FILTROS:
      return null;
    default:
      return state;
  }
}

const reducer = combineReducers({
  inscripcionesPorColegio,
  inscripcionesDelColegio,
  datosColegio,
  datosInscripcion,
  dataSaved,
  filtrosAplicados
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/confirmadas/reducers.js